// extracted by mini-css-extract-plugin
export default {"wrapperPage":"AboutUs_wrapperPage__RFKoE","title":"AboutUs_title__rctKw","content":"AboutUs_content__2dl1t","founders":"AboutUs_founders__Qhyk2"};